import React from 'react';
import {Field} from "formik";
import moment from "moment";
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateSelectorField = (props) => {
    // Fix is required for firefox and safari. Check in later releases if this has been fixed and remove
    // const onRef = (picker) => {
    //     if (picker) {
    //         const pickerEl = ReactDOM.findDOMNode(picker);
    //         pickerEl.tabIndex = -1;
    //     }
    // }

    return (
        <Field name={props.name}>
            {({field, form}) => {
                const selectedDate = field.value === undefined || field.value === null || field.value === '' || !field.value ? null : moment(field.value).toDate();
                return (
                    <>
                        <DatePicker
                            {...field}
                            selected={selectedDate}
                            onChange={(date) => form.setFieldValue(field.name, date)}
                            dateFormat={"dd/MM/yyyy"}
                            placeholderText={'DD / MM / YYYY'}
                            className={`form-control short`}
                            maxDate={moment().toDate()}
                            {...props}
                            autoComplete={"off"}
                            showYearDropdown
                            yearDropdownItemNumber={18}
                            scrollableYearDropdown
                        />

                        {form.touched[props.name] && form.errors[props.name] &&
                            <div className={'invalid mt-1'}>{form.errors[props.name]}</div>}
                    </>
                )
            }}
        </Field>
    )
}

DateSelectorField.propType = {
    name: PropTypes.string,
}

DateSelectorField.defaultProps = {
    name: '',
}

export default DateSelectorField;
